import { getCategoryColor } from './utils/colors';
import './TagList.css';

// Mapping for known categories: display name and fixed color
const mapping = {
  provider: { name: "Provider", color: "red" },
  content_type: { name: "Content Type", color: "green" },
  genre: { name: "Genre", color: "blue" },
  actor: { name: "Actor", color: "purple" },
};

// Simple capitalize utility (if not already imported)
const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

const TagList = ({ groupedTags, onTagClick }) => {
  if (!groupedTags.length) return null;

  // Sort categories based on mapping order, then alphabetically
  const sortedGroups = [...groupedTags].sort((a, b) => {
    const order = Object.keys(mapping);
    const indexA = order.indexOf(a.category);
    const indexB = order.indexOf(b.category);

    if (indexA !== -1 && indexB !== -1) return indexA - indexB;
    if (indexA !== -1) return -1;
    if (indexB !== -1) return 1;
    // Both not in mapping -> alphabetical
    return a.category.localeCompare(b.category);
  });

  return (
    <div className="tag-cloud">
      {sortedGroups.map(({ category, names }) => (
        <div key={category} className="tag-group">
          <div className="tag-group-items">
            {names.map((name) => (
              <button
                key={name}
                className="tag"
                style={{
                  backgroundColor: mapping[category]
                    ? mapping[category].color
                    : getCategoryColor(category),
                }}
                onClick={() => onTagClick(name)}
              >
                {name}
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default TagList;
